<template>
    <div>
        <header class="page-header">{{decodeURIComponent(workJson.workname)}}</header>
        <div class="page-container">
            <div class="subject-container">
                <div class="subject-left" style="background-color:#f6fcff;">
                    <div class="subject-top">
                        <!--  左侧内容  -->
                        <div class="subject-title">题面</div>
                        <!--  题面图片容器  -->
                        <div class="theme-box">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" :data-value="index"
                                         v-for="(item,index) in picUrls">
                                        <img class="item-img"
                                             style="max-height: 100%;max-width: 92%;width: 90%;height: 100%;"
                                             :src="item" v-on:click="previewImg(picUrls,index)">
                                    </div>
                                </div>
                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>
                                <!-- Add Arrows -->
                                <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div>
                            </div>
                        </div>
                    </div>
                    <!--整体报告-->
                    <div class="subject-statistics">
                <span class="footer-left">
                    <span class="title">整体报告</span>
                </span>
                        <!--<div class="overallReport"-->
                        <!--v-if="submitList.length>1 || (submitList.length == 1 && submitList[0])">-->
                        <div class="overallReport"
                             v-if="isSetAfter">
                            <div class="answerCondition">
                                <div class="overallTitle">答题情况</div>
                                <div class="answerReport">
                                    <p>题型：<span>{{getQuestype(workJson.workjson.questype)}}</span></p>
                                    <p>用时：</p>
                                    <p>参与：<span>{{submitCount}}/{{totalStudentCount}}</span></p>
                                    <p>班级：<span>{{decodeURIComponent(JSON.parse(workJson.workjson).classname)}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="statisticReport">
                                <div class="overallTitle">统计报告</div>
                                <div style="width: 320px;height: 66px">
                                    <div class="importWrong">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <template v-for="(item,index) in wrongWeight">
                                            <span>{{item}}</span>
                                        </template>
                                    </div>
                                </div>
                                <div class="pieReport" style="height:94px;margin-top:10px;">
                                    <div id="pieContainer" style="width:94px;height:94px"></div>
                                    <div class="pieLegend">
                                        <p><span></span>优秀： <span class="excellentCount">{{Math.round(excellentCount * 100) + '%'}}</span>
                                        </p>
                                        <p><span style="background-color:#ffca51;"></span>良好： <span
                                            class="goodCount">{{Math.round(goodCount * 100) + '%'}}</span></p>
                                        <p><span style="background-color:#f98376;"></span>合格： <span
                                            class="badCount">{{Math.round(badCount * 100) + '%'}}</span></p>
                                        <p><span style="background-color:#ff9b57;"></span>不合格： <span
                                            class="notGood">{{Math.round(notGoodCount * 100) + '%'}}</span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="allRight">
                                <div class="overallTitle">全部答对</div>
                                <div class="listContainer" v-if="allRightIds.length===0">
                                    <p v-if="allRightIds.length===0">当前没有学生全部答对，</p>
                                    <p>请再接再厉哦！</p>
                                </div>
                                <div class="listContainer" v-else>
                                    <template v-for="(item,index) in allRightIds">
                                        <span>{{ students[item] }}</span>
                                    </template>
                                </div>
                                <!--<div class="keyEvaluation">-->
                                <!--一键评价（+5）-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="reportNull" v-else>
                            <!--<p class="reportShow defaultShow"></p>-->
                            <p class="reportShow onlineTipShow"></p>
                        </div>
                    </div>
                </div>
                <div class="subject-right fill-right">
                    <!--  右侧内容  -->
                    <div class="reportTitle">
                        <span>答题报告{{newSubmitList.length}}</span>
                        <!--<span>答题报告{{Object.keys(newSubmitList[0][0]).quesid}}</span>-->
                    </div>
                    <ul class="result-list list-none fill-result-list">
                        <template v-for="(item,index) in newSubmitList">
                            <li class='result-item'>
                                <span>{{item.quesgroup}}</span>
                                <ul class='select-list list-none'>
                                    <template v-for="(subItem,subIndex) in item.submitList">
                                        <li class='selectEmpty-item'>
                                            <template v-for="(lableItem,lableIndex) in subItem.lables">
                                                <template v-if="subItem.isSetAfter">
                                                    <div class='emptyBlock answerRight' :data-qid="subItem.quesid"
                                                         v-if="lableItem.isset">
                                                        <p class='emptyContent'
                                                           :data-hands="subItem.raisehandsList.join(',')"
                                                           :data-id="subItem.options[lableIndex].selectids"
                                                           :data-qid="subItem.quesid"
                                                           :data-count="subItem.quesgroup"
                                                           v-on:click="lookAnswerInfo(lableItem.text,subItem.raisehandsList,subItem.options[lableIndex].selectids)">
                                                            {{lableItem.text}}
                                                        </p>
                                                        <span class='emptyCount'>{{ subItem.data[lableIndex].y }}</span>
                                                    </div>
                                                    <div class='emptyBlock answerWrong' :data-qid="subItem.quesid"
                                                         v-else>
                                                        <p class='emptyContent'
                                                           :data-hands="subItem.raisehandsList.join(' ,')"
                                                           :data-id="subItem.options[lableIndex].selectids"
                                                           :data-qid="subItem.quesid"
                                                           :data-count="subItem.quesgroup"
                                                           v-on:click="lookAnswerInfo(lableItem.text,subItem.raisehandsList,subItem.options[lableIndex].selectids)">
                                                            {{lableItem.text}}
                                                        </p>
                                                        <span class='emptyCount'>{{ subItem.data[lableIndex].y }}</span>
                                                    </div>
                                                </template>
                                                <template v-if="!subItem.isSetAfter">
                                                    <div class='emptyBlock' :data-qid=" + subItem.quesid">
                                                        <p class='emptyContent'
                                                           :data-hands="subItem.raisehandsList.join(',')"
                                                           :data-id="subItem.options[lableIndex].selectids"
                                                           :data-count="subItem.quesgroup"
                                                           v-on:click="lookAnswerInfo(lableItem.text,subItem.raisehandsList,subItem.options[lableIndex].selectids)"
                                                        >{{lableItem.text}}</p>
                                                        <span class='emptyCount'>{{ subItem.data[lableIndex].y }}</span>
                                                        <div class='selectAnswer' :data-txt="lableItem.text"
                                                             style='display: block' v-on:click="selectAnswer($event)">
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </li>
                                    </template>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <!--点击图表显示的人员名单弹框-->
        <div class="selectPersons" v-if="isShowModel">
            <div class="personsContainer">
                <div class="personHeader">答案详情</div>
                <div class="personContent"
                     style="background-color:#f6fcff;height: 640px;padding:18px;position: relative">
                    <div class="personAnswer" style="width: 1244px">
                        {{curAnswerInfo}}
                    </div>
                    <div class="personList" style="width: 1244px">
                        <template v-for="item in curStuList">
                            <span v-if="curHandsList.indexOf(item)==-1">{{students[item]}}</span>
                            <span class='putHands' v-else>{{students[item]}}</span>
                        </template>
                    </div>
                    <p class="personNumber">共 <span class="stuCount">{{curStuList.length}}</span> 人</p>
                    <button class="closePersonList" style="position: absolute;left: 50%;margin-left:-80px;bottom:20px"
                            v-on:click="isShowModel=false">
                        关闭
                    </button>
                </div>
            </div>
        </div>
        <!-- 预览轮播 -->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->

        <!-- 预览轮播 -->
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import * as API from '../../../../service/cloudReport/index'

    // const previewSlider = () => import("../baseData/previewSlider");

    export default {
        name: "fill-report",
        computed: {
            ...mapGetters([
                'interactPath',
                'interactPBPath'
            ]),
        },
        // components: {
        //     previewSlider
        // },
        data () {
            return {
                workId: this.$route.params.workId,
                isSetAnswer: '',//是否设置过答案
                reportObj: null,
                userListPB: null,
                questionInfoPb: null,
                calcPB: null,
                quesDetailsPb: null,
                students: [],
                workJson: '',//pb文件中取出的报告json
                workjson: '',
                picUrls: [],//题目集合,
                submitCount: 0,//提交人数
                submitList: [],
                newSubmitList: [],//整合后的提交集合
                submitListIds: [],
                fillList: [],
                questions: [],
                calcData: {},//小题集合
                answerList: [],
                userList: [],
                allRightIds: [],
                excellentIds: [],
                goodIds: [],
                badIds: [],
                notGoodIds: [],
                totalStudentCount: 0,
                excellentCount: 0,
                goodCount: 0,
                badCount: 0,
                notGoodCount: 0,
                wrongWeight: [],         //错题权重
                raisehandsList: [],// 举手人员列表
                colorArr: ['#5cb3ff', '#ffca51', '#f98376', '#FF9B57'],
                isSetAfter: false,
                isShowModel: false,//是否显示答案详情框
                curAnswerInfo: '',//弹框当前学生姓名
                curStuList: [],//弹框学生集合
                curHandsList: [],
                previewMode: false,
                previewVideoMode: false,
                videoSrc: ""
            }
        },
        methods: {
            /**
             * 获取userList
             */
            loadUserList () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fuserlist.pb",
                    pb: _this.userListPB,
                    success: function (resp) {
                        try {
                            if (Object.keys(resp).length === 0) { // 判断指定参数是否是一个空对象
                                var logStr = "学生列表:" + JSON.stringify(resp);
                                console.error(logStr);
                            }
                            _this.loadUserObj(resp);
                            _this.getInertactInfo();
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fuserlist.pb");
                    }
                });
            },
            /**
             *  处理学生对象
             */
            loadUserObj (u) {
                // localStorage.setItem('stuListLength',u.userlist.length);
                for (var i = 0; i < u.userlist.length; i++) {
                    var uid = u.userlist[i].stuid.replace(/m_/g, '');
                    this.students[uid] = decodeURIComponent(u.userlist[i].stuname);
                    this.userList.push(uid);
                }
                this.totalStudentCount = Object.keys(this.students).length;
            },
            /**
             * 根据报告id获取报告详情
             */
            async getInertactInfo () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fwork.pb",
                    pb: _this.questionInfoPb,
                    success: function (resp) {
                        try {
                            _this.workJson = resp;
                            _this.loadWorkObj(resp);
                            _this.loadCalcJson();
                        }
                        catch (error) {
                        }
                    },
                    fail: function () {
                        console.error("get resource err url=" + _this.interactPBPath + this.workId + "%2Fwork.pb");
                    }
                });
            },
            /**
             * 请求公共方法
             */
            getData (option) {
                // fetcdhGET(option.url + "?version=" + new Date().getTime(), {resType: "arraybuffer"}).then((resp) => {
                //     var res = option.pb.decode(resp);
                //     console.log(res);
                //     option.success(res);
                // }, (error) => {
                //     console.error(error);
                //     option.fail();
                // });

                API.GET(option.url + "?version=" + new Date().getTime()).then(function (resp) {
                    var res = option.pb.decode(resp.data);
                    console.log(res);
                    option.success(res);
                }).catch(function (error) {
                    console.error(error);
                    option.fail();
                });
            },
            initProtobuf () {
                if (typeof dcodeIO === 'undefined' || !dcodeIO.ProtoBuf) {
                    throw(new Error("ProtoBuf.js is not present."));
                }
                // 创建ProtoBuf
                var ProtoBuf = dcodeIO.ProtoBuf;
                var ClsModel = ProtoBuf.loadProtoFile("/static/pb/cls.proto");

                this.userListPB = ClsModel.build("UserList");
                this.questionInfoPb = ClsModel.build("QuestionInfoPb");
                this.calcPB = ClsModel.build("CalcPb");
                this.quesDetailsPb = ClsModel.build("QuesDetailsPb");
                // this.StuAnswerPb = ClsModel.build("StuAnswerPb");
            },
            loadWorkObj (w) {
                let workname = decodeURIComponent(this.workJson.workname);
                // this.groupnum = w.stugroup;
                // this.wType = w.worktype;
                // this.qtype = w.questype;
                this.questions = w.questions;
                // this.workjson = w.workjson;
                //拼接题面图片集合
                let picArray = this.workJson.imgpaths;
                let teacherUid = this.workJson.userid;
                for (let i = 0; i < picArray.length; i++) {
                    let item = this.interactPath + "/upload/" + teacherUid + "/" + picArray[i];
                    this.picUrls.push(item);
                }
                let quesArray = this.workJson.questions;
                for (let i = 0; i < quesArray.length; i++) {
                    this.answerList.push(quesArray[i].answer);
                }

                //初始化题面swiper
                this.initQuesImgSwiper();
            },
            /**
             * 初始化题面swiper
             */
            initQuesImgSwiper () {

                this.$nextTick(() => {
                    var img_url = this.picUrls[0];
                    // 创建对象
                    var img = new Image();
                    // 改变图片的src
                    img.src = img_url;

                    // var swiper = new Swiper('.swiper-container', {
                    //     pagination: {
                    //         el: '.swiper-pagination',
                    //         type: 'fraction'
                    //     },
                    //     navigation: {
                    //         nextEl: '.swiper-button-next',
                    //         prevEl: '.swiper-button-prev'
                    //     }
                    // });
                });
            },
            /**
             * 转换题目类型为中文
             */
            getQuestype (questype) {
                var workName = '';
                switch (questype) {
                    case 'choice':
                        workName = '选择题';
                        break;
                    case 'judge':
                        workName = '判断题';
                        break;
                    case 'subject':
                        workName = '主观题';
                        break;
                    default:
                        workName = '填空题';
                }
                return workName;
            },
            /**
             * 小题统计
             */
            loadCalcJson () {
                var _this = this;
                _this.getData({
                    url: _this.interactPBPath + this.workId + "%2Fcalc.pb",
                    pb: _this.calcPB,
                    success: function (resp) {
                        try {
                            _this.submitCount = parseInt(resp.stuCount);
                            _this.calcData = resp.calc;
                            _this.loadCalcData(resp);
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    fail: function () {
                    }
                });
            },
            loadCalcData (c) {
                for (var i = 0; i < c.calc.length; i++) {
                    var qid = c.calc[i].quesid;
                    this.loadQidJson(qid);
                }
            },
            loadQidJson (qid) {
                var qidUrl = this.interactPBPath + this.workId + "/" + qid + ".pb";
                var _this = this;
                _this.getData({
                    url: qidUrl,
                    pb: _this.quesDetailsPb,
                    success: function (resp) {
                        try {
                            _this.submitList.push(resp);
                            _this.loadQidObj(resp, qid);
                            if (_this.submitList.length == _this.questions.length) {
                                _this.shortSubimtList();
                            }
                        }
                        catch (error) {
                            console.error(error);
                        }
                    },
                    error: function () {
                        console.error("get resource err url=" + qidUrl);
                    }
                });
            },
            loadQidObj (data, qid) {
                var map = new Map();

                delete map._c;
                var detail = data.options;
                for (var j = 0; j < detail.length; j++) {
                    var result = detail[j];
                    map[result.title] = result.selectids;
                }

                var obj = Object.values(map);
                //根据数组长度排序  答案一致人数
                obj.sort(function (a, b) {
                    a.length > b.length
                }).map(function (value, index, array) {
                })

                var answers = Object.keys(map);
                var ids = Object.values(map);
                var others = [];
                var _answer = [];
                var _ids = [];
                var _count = [];
                for (var i = 0; i < answers.length; i++) {
                    _answer.push(decodeURIComponent(answers[i]));
                    _ids.push(ids[i]);
                    _count.push(ids[i].length);
                }
                this.fillList[qid] = {answers: _answer, ids: _ids, count: _count};
            },
            shortSubimtList () {
                var _this = this;
                var tempList = [];
                for (var i = 0; i < _this.questions.length; i++) {
                    tempList[i] = _this.submitList.getValue("quesid", this.questions[i].quesid);
                }
                this.submitList = tempList;
                this.calcScoreLevel();
                //处理submitList
                _this.handleSubmitList();

            },
            /**
             * 处理分数等级
             */
            calcScoreLevel () {
                this.userList = this.$utils.removalArray(this.userList);
                for (var i = 0; i < this.userList.length; i++) {
                    var rightCount = 0;
                    console.log(this.workJson);
                    console.log(this.workjson);
                    for (var j = 0; j < this.calcData.length; j++) {
                        if (this.calcData[j].rightids.includes(this.userList[i]) || this.calcData[j].wrongids.includes(this.userList[i])) {
                            this.submitListIds.push(this.userList[i]);
                        }
                        if (this.calcData[j].rightids.includes(this.userList[i])) {
                            rightCount++;
                        }
                        //答错人数大于答对人数
                        if (this.calcData[j].rightids.length < this.calcData[j].wrongids.length)
                            this.wrongWeight.push(this.questions.getValue("quesid", this.calcData[j].quesid).quesgroup);
                    }
                    if (rightCount == this.questions.length) {
                        //全部答对
                        this.allRightIds.push(this.userList[i]);
                    }
                    if (rightCount >= this.questions.length * 0.9) {
                        //优秀
                        this.excellentIds.push(this.userList[i]);
                    } else if (rightCount >= this.questions.length * 0.7) {
                        //良好
                        this.goodIds.push(this.userList[i]);
                    } else if (rightCount >= this.questions.length * 0.6) {
                        //合格
                        this.badIds.push(this.userList[i]);
                    } else if (rightCount < this.questions.length * 0.6) {
                        //不合格(去掉未提交的人)
                        this.notGoodIds.push(this.userList[i]);
                        for (var k = 0; k < this.notGoodIds.length; k++) {
                            if (!this.submitListIds.includes(this.notGoodIds[k])) {
                                this.notGoodIds.splice(k, 1);
                            }
                        }
                    }
                }
                this.$utils.removalArray(this.notGoodIds);
                this.excellentCount = (this.excellentIds.length / this.submitCount);
                this.goodCount = (this.goodIds.length / this.submitCount);
                this.badCount = (this.badIds.length / this.submitCount);
                this.notGoodCount = (this.notGoodIds.length / this.submitCount);

                //错题集合排序
                this.wrongWeight = this.$utils.reduseRepeatSort(this.wrongWeight);
            },
            /**
             * 处理submitList
             */
            handleSubmitList () {
                //第一步遍历数据
                let _this = this;
                let quesgroup = 0; // 题目数量
                _this.submitList.forEach(function (item, index) {
                    //判断quesgroup是否已存在 存在 则往已存在的对象里加 不存在则新建
                    if (item != null) {
                        let newObj = {};
                        newObj.quesgroup = item.quesgroup;
                        newObj.submitList = [];
                        if (quesgroup != item.quesgroup) {
                            item = _this.appendPorps(item);
                            newObj.submitList.push(item);
                            _this.newSubmitList.push(newObj);
                            quesgroup = item.quesgroup;
                        }
                        else {
                            //查找已存在的对象
                            _this.newSubmitList.forEach(function (newItem, newIndex) {
                                if (newItem.quesgroup === item.quesgroup) {
                                    item = _this.appendPorps(item);
                                    newItem.submitList.push(item);
                                }
                            });

                        }

                    }
                });
                this.$nextTick(() => {
                    this.loadPie();
                });
            },
            /**
             * 处理学生答案 追加 data，lables，colorList 实现dom渲染
             */
            appendPorps (item) {
                let _this = this;
                item.raisehandsList = _this.getHandsList(item.quesid);
                var data = [];
                var lables = [];
                var qAnswer = _this.fillList[item.quesid]; // 根据quesid获取到{"answers":["",""],"ids":[[""],[""]],"count":[1,1]} 学生回答的答案
                for (var j = 0; j < qAnswer.answers.length; j++) {
                    var type = 0;
                    if (item.answer != "" && item.answer != "undefined") {
                        var answerList = [];
                        item.answer.split(',').forEach(function (items) {
                            decodeURIComponent(items).split(',').forEach(function (elem) {
                                answerList.push(decodeURIComponent(elem));
                            })

                        });
                        type = answerList.includes(qAnswer.answers[j]) ? 1 : -1;
                    }
                    var color = "#0199ff";
                    if (type == -1)
                        color = "#ff5762";
                    else if (type == 1)
                        color = "#21e590";
                    data.push({y: qAnswer.count[j], color: color}); // 答题人数，颜色
                    lables.push({text: qAnswer.answers[j], isset: type == 1});
                }
                var colorList = [];
                data.forEach(function (item) {
                    colorList.push(item.color);
                });

                for (var i = 0; i < lables.length; i++) {
                    if (data[i].y === 1) {
                        data[i].y = _this.students[item.options[i].selectids]
                    } else {
                        data[i].y = data[i].y + '人'
                    }
                }

                item.data = data;
                item.lables = lables;
                item.colorList = colorList;

                var isSetAfter = false; // 是否已经设置过答案

                if (colorList.indexOf("#ff5762") > -1 || colorList.indexOf("#21e590") > -1) {
                    isSetAfter = true;
                } else {
                    isSetAfter = false;
                }
                item.isSetAfter = isSetAfter;
                _this.isSetAfter = isSetAfter;
                return item;
            },
            /**
             * 根据题目id获取每一题的举手人员列表
             */
            getHandsList (quesid) {
                let _this = this;
                _this.raisehandsList = [];
                for (var i = 0; i < _this.calcData.length; i++) {
                    if (quesid == _this.calcData[i].quesid) {
                        _this.raisehandsList = _this.calcData[i].raisehands.split(',');
                        break;
                    }
                }
                return _this.raisehandsList;
            },
            /**
             * 选择答案的样式变化
             */
            selectAnswer ($event) {
                if ($event.currentTarget.className.indexOf("selectChecked") >= 0) {
                    $event.currentTarget.className = "selectAnswer"
                } else {
                    $event.currentTarget.className = "selectAnswer selectChecked"
                }
            },
            /**
             * 加载拼图
             */
            loadPie () {
                let dataSourcePie = this.$echarts.init(document.getElementById('pieContainer'));
                let pieData = [];
                pieData.push(
                    {
                        name: '优秀',
                        value: this.excellentCount
                    },
                    {
                        name: '良好',
                        value: this.goodCount
                    },
                    {
                        name: '及格',
                        value: this.badCount
                    },
                    {
                        name: '不合格',
                        value: this.notGoodCount
                    });
                const option = {
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '90%',
                            center: ['50%', '50%'],
                            data: pieData,
                            labelLine: {
                                show: false
                            },
                            hoverAnimation: false,
                            hoverOffset: 0,
                            color: this.colorArr
                        }
                    ]
                };
                dataSourcePie.setOption(option);
            },
            /**
             * 点击学生作答查看作答详情
             */
            lookAnswerInfo (text, raisehandsList, selectidList) {
                let _this = this;
                _this.curAnswerInfo = text;
                _this.curStuList = [];
                _this.curHandsList = [];

                raisehandsList.forEach(function (item) {
                    _this.curHandsList.push(item);
                });
                selectidList.forEach(function (item) {
                    _this.curStuList.push(item);
                });
                _this.isShowModel = true;
            },
            /**
             * 预览图片
             */
            previewImg (imgArr, index) {
                this.previewMode = true;
                //处理图片集合
                this.$refs.previewSlider.swiperInitByImgArr(this.convertImgArr(imgArr), index);
            },
            // 关闭预览
            closePreview (type) {
                this[type] = false;
            },
            /**
             *处理图片集合
             */
            convertImgArr (imgArr) {
                let imgArrData = [];
                imgArr.forEach(function (item) {
                    let imgObj = {};
                    imgObj.url = item;
                    imgArrData.push(imgObj);
                });

                return imgArrData;
            }
        },
        mounted () {
            //根据报告id获取报告详情
            this.initProtobuf();
            this.loadUserList();
        }
    }
</script>

<style lang="css" scoped>
    @import "../../../../style/cloudReport/normalize.css";
    @import "../../../../style/cloudReport/main.css";
    @import "../../../../style/cloudReport/objectReport.css";
</style>
<style lang="css">
    .swiper-container {
        width  : 100%;
        height : 100%;
    }

    .swiper-slide {
        text-align              : center;
        font-size               : 18px;
        background              : #fff;

        /* Center slide text vertically */
        display                 : -webkit-box;
        display                 : -ms-flexbox;
        display                 : -webkit-flex;
        display                 : flex;
        -webkit-box-pack        : center;
        -ms-flex-pack           : center;
        -webkit-justify-content : center;
        justify-content         : center;
        -webkit-box-align       : center;
        -ms-flex-align          : center;
        -webkit-align-items     : center;
        align-items             : center;
    }
</style>
